import store from 'dashboard/store';
import PatientOverviewMedicationProgress from 'dashboard/templates/views/Patient/Medication/PatientOverviewMedicationProgress';

export default {
  path: 'progress',
  name: 'PatientRecordMedicationProgress',
  component: PatientOverviewMedicationProgress,
  meta: {
    // title: 'Patient Record - Medication - Progress',
    title: t => `${t('patient.patientRecord')} - ${t('screens.medicationAdherenceScreen', 'app_mobile')} - ${t('journeyProgress.progress')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  },
  async beforeEnter(to, from, next) {
    const currentPatientId = from.params?.patientId;
    const newPatientId = to.params?.patientId;

    // Update user if back is used as everything stays cached in computed
    if ((currentPatientId === undefined && newPatientId) ||
        currentPatientId !== undefined && newPatientId !== undefined && currentPatientId !== newPatientId
    ) {
      await Promise.all([
        store.dispatch('patientSummary/get', newPatientId, {root: true}),
      ]);
    }

    if (parseInt(store.getters['patientSummary/currentVersion']) <= 2) {
      // Only show status on first SDM Encounter (v2 - m0 - PPP)
      next({
        name: 'PatientRecordMedicationStatus',
        params: { patientId: to.params.patientId },
      });
    } else {
      next();
    }
  },
};
